import React, {useEffect} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import useValetStore from "./hooks/useValetStore";
import FormatUtils from "../../utils/FormatUtils";
import {RouteType} from "./constants/RouteType";


import IconListCheck from "../../assets/v2/list-checks.png";
import IconShieldCheck from "../../assets/v2/shield-check.png";
import IconCalendar from "../../assets/v2/calendar-clock.png";
import IconMailCheck from "../../assets/v2/mail-check.png";
import ValetRouteGraph from "./ValetRouteGraph";
import {useTranslation} from "react-i18next";


export default function ValetOurPrice({
                                          backClickedHandler,
                                          nextClickedHandler
                                      }) {

    const {
        valetIntent,
        userData
    } = useValetStore();

    const FormatGoogleAdress = (address) => {
        return address.split(',').map((it, i) => <div key={'x' + i}>{it}</div>)
    }

    const {t} = useTranslation('common');

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={20}/>
        <div className="text-white text-[30px] font-bold">
            {t("valet.our_price.title")}
        </div>

        <div className="flex flex-nowrap justify-left items-center">
            <div
                className="whitespace-nowrap rounded-3xl bg-[#00ae11] text-2xl font-bold py-2 px-7">{FormatUtils.formatAmount(valetIntent.price, true)}</div>
            <div
                className="px-4 text-lg">{t("valet.our_price.route_type")}<b> {userData.travel.routeType === RouteType.GOING ? t("valet.our_price.route_type_going") : t("valet.our_price.route_type_going_and_coming")} </b> {t("valet.our_price.of")} {FormatUtils.formatDistance(valetIntent.gmap_distance)}.
            </div>
        </div>

        <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
            <legend className="text-sm">&nbsp;{t("valet.our_price.summary")}&nbsp;</legend>
            <div className="flex">
                <ValetRouteGraph routeType={userData.travel.routeType}/>
                <div className="grow">
                    <div><b>{t("valet.our_price.origin")}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_origin)}
                    <div className="mt-3"></div>
                    <div><b>{t("valet.our_price.destination")}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_destination)}
                </div>
            </div>
        </fieldset>
        <div
            className="bg-gradient-to-b from-black/50 to-black/0 rounded-t-3xl text-2xl flex flex-col justify-center text-center content-center p-1 gap-2">
            <div className="text-white text-[13px] font-bold">
                {t("valet.our_price.text")}
            </div>
            <div className="flex content-center gap-4 items-center">
                <img src={IconListCheck}/>
                <div className="text-[13px]">{t("valet.our_price.text2")}</div>
            </div>
            <div className="flex content-center gap-4 items-center">
                <img src={IconShieldCheck}/>
                <div className="text-[13px]">{t("valet.our_price.text3")}</div>
            </div>
            <div className="flex content-center gap-4 items-center">
                <img src={IconCalendar}/>
                <div className="text-[13px]">{t("valet.our_price.text4")}</div>
            </div>
            <div className="flex content-center gap-4 items-center">
                <img src={IconMailCheck}/>
                <div className="text-[13px]">{t("valet.our_price.text5")}</div>
            </div>
        </div>
        <div className="grow"></div>
        <Button text={t("valet.our_price.btn_continue")} clickHandler={nextClickedHandler}/>
        <Button outline text={t("valet.our_price.btn_modify")} clickHandler={backClickedHandler}/>
    </div>
}